export const PMA_TOOLS = [
  'icc2',
  'prime',
  'dc',
  'syn',
  'wv',
  'customcompiler',
  'vcs',
  'verdi',
  'hspice',
  'icvalidator',
  'starrc',
];

export const PMA_DEFAULT_TOOLS =
  'icc2=1:prime=1:dc=1:syn=1:wv=1:customcompiler=1:vcs=1:verdi=1:hspice=1:customcompiler=1:icvalidator=1:starrc=1';

export const PMA_TOOLS_PRESETS = [PMA_DEFAULT_TOOLS, 'vcs=1:verdi=1'];

export function parsePmaTools(value) {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return [];
  const allowed = new Set(PMA_TOOLS);
  const selected = new Set();
  raw.split(':').forEach((part) => {
    const name = String(part.split('=')[0] || '')
      .trim()
      .toLowerCase();
    if (allowed.has(name)) selected.add(name);
  });
  return PMA_TOOLS.filter((tool) => selected.has(tool));
}

export function formatPmaTools(value) {
  const selected = Array.isArray(value) ? value : parsePmaTools(value);
  const allowed = new Set(selected.map((tool) => String(tool || '').trim().toLowerCase()));
  const ordered = PMA_TOOLS.filter((tool) => allowed.has(tool));
  if (ordered.length === PMA_TOOLS.length) return PMA_DEFAULT_TOOLS;
  return ordered.map((tool) => `${tool}=1`).join(':');
}

export function togglePmaTool(currentTools, tool) {
  const selected = new Set(parsePmaTools(currentTools));
  if (selected.has(tool)) selected.delete(tool);
  else selected.add(tool);
  return formatPmaTools(PMA_TOOLS.filter((name) => selected.has(name)));
}

/** Primary group → /ve/{group}_home (po → /ve/po_home, ws → /ve/ws_home, cg → /ve/cg_home). PDK groups are often secondary. */
export const PMA_LINUX_GROUPS = ['po', 'ws', 'cg', 'pdkcc', 'pdk14', 'pdk32', 'pdk40'];

export const PMA_VNC_FQDNS = [
  'ws2.trg.vlsiexpert.in:12340',
  'ws2v.trg.vlsiexpert.in:56781',
  'prac2.trg.vlsiexpert.in:23452',
  'prac3.trg.vlsiexpert.in:23453',
  'co4.trg.vlsiexpert.in:45674',
  'up1.trg.vlsiexpert.in:45673',
  'trg-setups-1.trg.vlsiexpert.in:23451',
  'wsv3.trg.vlsiexpert.in:56783',
  'ws4.trg.vlsiexpert.in:56784',
  'ws1.trg.vlsiexpert.in:23451',
  'prac4v.trg.vlsiexpert.in:23454',
  'ws5v.trg.vlsiexpert.in:56785',
  'cg1v.trg.vlsiexpert.in:56786',
];

export const PMA_PUTTY_FQDNS = PMA_VNC_FQDNS;
export const PMA_LAB_FQDNS = PMA_VNC_FQDNS;

function pmaFqdnShortHost(fqdn) {
  return String(fqdn || '')
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, '')
    .split('.')[0];
}

export function isCgLabHost(fqdn) {
  return pmaFqdnShortHost(fqdn).startsWith('cg');
}

/** cg1v and other cg* hosts use group cg → /ve/cg_home, not po. */
export function linuxGroupsForCgHost(groups, fqdn) {
  const list = Array.isArray(groups)
    ? groups.map((g) => String(g || '').trim().toLowerCase()).filter(Boolean)
    : [];
  if (!isCgLabHost(fqdn)) return list;
  return ['cg', ...list.filter((g) => g !== 'cg' && g !== 'po')];
}
